/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Search, XCircle } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { UserContext } from "../../../src/context/userContext";
import { Image } from "antd";
import ProjeXLogo from "../../assets/ProjeX.png";
import { getLeaveNotifications } from "../../service/leavesEmployeeApiService";

const Header = () => {
  const route = all_routes;
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  const slideDownSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "block";
      }
    }
  };

  const slideUpSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextcElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "none";
      }
    }
  };

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);

  const handleDropdownToggle = () => {
    console.log("Dropdown toggled, isOpen:", !isDropdownOpen);
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClearNotifications = () => {
    setNotifications([]);
    console.log("Notifications cleared locally");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        console.log("Clicked outside, closing dropdown");
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   const fetchNotifications = async () => {
  //     try {
  //       console.log("userData:", userData);
  //       const userId = userData?.data?._id;
  //       if (!userId) {
  //         console.warn("No userId found, skipping notification fetch");
  //         setNotifications([]);
  //         alert("User not logged in");
  //         return;
  //       }
  //       const notificationsData = await getLeaveNotifications(userId);
  //       console.log("Notifications set:", notificationsData);
  //       setNotifications(Array.isArray(notificationsData) ? notificationsData : []);
  //     } catch (error) {
  //       console.error("Failed to fetch notifications:", error);
  //       setNotifications([]);
  //       alert(error.message || "Failed to load notifications");
  //     }
  //   };
  //
  //   fetchNotifications();
  //   const interval = setInterval(fetchNotifications, 30000);
  //   return () => clearInterval(interval);
  // }, [userData?.data?._id]);

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        const target = e.target.closest(".sidebar, .header-left");

        if (target) {
          body.classList.add("expand-menu");
          slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          slideUpSubmenu();
        }

        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []);

  useEffect(() => {
    if (userData === null) {
      navigate("/signin");
    }

    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };

  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  const formatTimeAgo = (date) => {
    const now = new Date();
    const diff = Math.floor((now - new Date(date)) / 1000);

    if (diff < 60) return `${diff} seconds ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
    return `${Math.floor(diff / 86400)} days ago`;
  };

  return (
    <>
      <div className="header">
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          <Link to="/dashboard" className="logo logo-normal">
            <ImageWithBasePath
              className="w-100 h-40 border-2 border-red-500"
              src={ProjeXLogo}
              alt="img"
            />
          </Link>
          <Link to="/dashboard" className="logo logo-white">
            <ImageWithBasePath
              className="w-100 h-40 border-2 border-red-500"
              src={ProjeXLogo}
              alt="img"
            />
          </Link>
          <Link to="/dashboard" className="logo-small"></Link>
        </div>
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        <ul className="nav user-menu">
          <li className="nav-item nav-searchinputs">
            <div className="top-nav-search" style={{display:"none"}}>
              <Link to="#" className="responsive-search">
                <Search />
              </Link>
              <form action="#" className="dropdown">
                <div
                  className="searchinputs dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="false"
                >
                  <div className="search-addon">
                    <span>
                      <XCircle className="feather-14" />
                    </span>
                  </div>
                </div>
                <div
                  className="dropdown-menu search-dropdown"
                  aria-labelledby="dropdownMenuClickable"
                  style={{ display: "none" }}
                ></div>
              </form>
            </div>
          </li>
          <li className="nav-item dropdown nav-item-box">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
              onClick={handleDropdownToggle}
            >
              <FeatherIcon icon="bell" />
              <span className="badge rounded-pill">{notifications?.length || 0}</span>
            </Link>
            <div
              ref={dropdownRef}
              className={`dropdown-menu notifications ${isDropdownOpen ? "show" : ""}`}
              style={{
                minWidth: "300px",
                maxHeight: "400px",
                overflowY: "auto",
                zIndex: 1000,
                position: "absolute",
                right: 0,
                top: "calc(100% - 10px)",
                background: "#fff",
                border: "1px solid #ddd",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                transform: "translateY(-10px)",
              }}
            >
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <Link to="#" className="clear-noti" onClick={handleClearNotifications}>
                  {" "}
                  Clear All{" "}
                </Link>
              </div>
              <div className="noti-content">
<ul className="notification-list" style={{ listStyle: "none", padding: 0, margin: 0 }}>
  {!notifications || notifications.length === 0 ? (
    <li className="notification-message">
      <div className="media d-flex">
        <div className="media-body flex-grow-1">
          <p className="noti-details" style={{ fontSize: "14px", margin: 0 }}>
            No new notifications
          </p>
        </div>
      </div>
    </li>
  ) : (
    notifications.map((notification, index) => (
      <li
        key={index}
        className={`notification-message ${
          notification.message.includes("pending") ? "active" : ""
        }`}
        style={{
          padding: "10px",
          borderBottom: "1px solid #f0f0f0",
        }}
      >
        <Link to="/leaves-employee">
          <div className="media d-flex">
            <span className="avatar flex-shrink-0">
              <ImageWithBasePath
                alt="img"
                src="assets/img/profiles/avatar-02.jpg"
              />
            </span>
            <div className="media-body flex-grow-1">
              <p className="noti-details" style={{ fontSize: "14px", margin: 0 }}>
                {notification.message}
              </p>
              <p className="noti-time" style={{ fontSize: "12px", margin: 0 }}>
                <span className="notification-time">
                  {notification.time} {/* Use backend-provided time */}
                </span>
              </p>
            </div>
          </div>
        </Link>
      </li>
    ))
  )}
</ul>
              </div>
              <div className="topnav-dropdown-footer">
                {/* <Link to="/leaves-employee">View all Notifications</Link> */}
              </div>
            </div>
          </li>
          <li className="nav-item nav-item-box">
            <Link to="/signin">
              <FeatherIcon icon="log-out" />
            </Link>
          </li>
        </ul>
        <div className="dropdown mobile-user-menu" style={{display: "none"}}>
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to="profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="generalsettings">
              Settings
            </Link>
            <Link className="dropdown-item" to="signin">
              Logout
            </Link>
          </div>
        </div>
      </div>
  
    </>
  );
};

export default Header;